module.exports = __webpack_public_path__ + "static/media/SPMS_SE_MobileLogo.ae56faef.png";